import { render, staticRenderFns } from "./FleetTariffsForm.vue?vue&type=template&id=7a645e0f&"
import script from "./FleetTariffsForm.vue?vue&type=script&lang=js&"
export * from "./FleetTariffsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a645e0f')) {
      api.createRecord('7a645e0f', component.options)
    } else {
      api.reload('7a645e0f', component.options)
    }
    module.hot.accept("./FleetTariffsForm.vue?vue&type=template&id=7a645e0f&", function () {
      api.rerender('7a645e0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fleets/Forms/FleetTariffsForm.vue"
export default component.exports